module.exports = __webpack_public_path__ + "ddfbe2388bc4881d3925e5c891de9d2c.MP3";